import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.WatchService = function () {

};

HSN.Service.WatchService.prototype =
{
    GetChannelListing: function (zipCode, config) {
        this._send("/watch/getlistings", { zipCode: zipCode }, 'GET', 'html', config);
    },
        
    GetSearchForm: function (config) {
        this._send("/watch/getsearch", { }, 'GET', 'html', config);
    },
        
    GetDailyProgramGuide: function (date, network, timeOffset, config) {
        this._send("/watch/getdailyprogramguide", {date : date, network: network, timeOffset : timeOffset}, 'GET', 'html', config);
    },
        
    GetWeeklyProgramGuide: function (date, network, timeOffset, config) {
        this._send("/watch/getweeklyprogramguide", { date: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },
        
    GetShowProducts: function (date, network, timeOffset, config) {
        config.isCacheable = true;
        this._send("/watch/getshowproducts", { showDate: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },
        
    GetRecentlyAiredView: function (date, network, timeOffset, config) {
        this._send("/watch/getrecentlyairedview", { date: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },

    GetShowDetails: function (network, startDate, endDate, timeOffset, config) {
        this._send("/watch/program-guide/showdetails", { Network: network, StartDate: startDate, EndDate: endDate, TimeOffSet: timeOffset }, 'GET', 'html', config);
    },

    GetSearchResults: function (timeOffset, network, query, config) {
        this._send("/watch/search", { Network: network, TimeOffSet: timeOffset, Query: query }, 'GET', 'html', config);
    },
        
    GetVideoTitle: function (date, network, title, config) {
        this._send("/watch/getvideotitle", { date: date, network: network, title: title }, 'GET', 'html', config);
    },
        
    GetShowProduct: function (network, productId, config) {
        config.isCacheable = true;
        this._send("/watch/getshowproduct", { network: network, productId: productId }, 'GET', 'html', config);
    },

    GetShowProductFeed: function (date, network, config) {
        this._send("/watch/getshowproductfeed", { date: date, network: network }, 'GET', 'html', config);
    },
        
    ContactUs: function (data, config) {
        this._send("/watch/contactus", data, "POST", "json", config);
    },

    //=====PRINT LAYOUTS=====
    GetDailyPrintLayout: function(data, config) {
        this._send('/watch/program-guide/print/daily', data, 'GET', 'html', config);
    },
    GetWeeklyPrintLayout: function(data, config) {
        this._send('/watch/program-guide/print/weekly', data, 'GET', 'html', config);
    },
    GetFullPrintLayout: function(data, config) {
        this._send('/watch/program-guide/print/monthly', data, 'GET', 'html', config);
    },
    GetSearchPrintLayout: function(data, config) {
        this._send('/watch/program-guide/print/search', data, 'GET', 'html', config);
    },
    //=====END PRINT LAYOUTS=====

    //Past Show - item update
    GetPastShowProduct: function(productId, config) {
        this._send('/watch/past-shows/product', { productId: productId }, 'GET', 'html', config);
    },

    _send: function (url, data, type, dataType, config) {
        config = (config = config || {});

        if (!config.isCacheable) {
            if (typeof data === 'string') {
                var joiner = data.indexOf("=") === -1 ? "" : "&";
                data += joiner + "_ts=" + new Date().getTime();
            } else {
                data['_ts'] = new Date().getTime();
            }
        }

        $.ajax
        (
            url,
            {
                type: type,
                data: data,
                context: this,
                dataType: dataType,
                success: function (data, status, xhr) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), data);
                },
                error: function (xhr, status, error) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), false);
                }
            }
        );
    },
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/WatchService.js